// extracted by mini-css-extract-plugin
export default {"container":"style_container__NDlpn","tabGlider":"style_tabGlider__xkaKp","tabElem":"style_tabElem__1Tpn-","tabElemActive":"style_tabElemActive__cqVkf"};